import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController, NavParams, ViewController, ToastController, Events, LoadingController } from 'ionic-angular';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ExcelService } from '../../providers/excel-service/excel-service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotifyServiceProvider } from '../../providers/notify-service/notify-service'
declare var jQuery: any;
import * as XLSX from 'xlsx';
const nav = (window.navigator as any);
@Component({
  selector: 'page-excel-upload',
  templateUrl: 'excel-upload.html',
})

export class ExcelUploadPage {
  @Output() clear_excelUpload_page = new EventEmitter<any>();
  uploadFields: any = [];
  uniqueField: boolean = true;
  importFile: any = "";
  selectFile: any = ""
  objCurrentTemplates: any = [];
  showDupliacte: boolean = false;
  dropdownSettings: any = [];
  selectField: any = [];
  outputFields: any = [];
  formData = new FormData();
  selectedValue: any;
  loader: any;
  defaultValue = "Update duplicate"
  emptyExcel = true;
  currentFolderTemplate: any = [];

  constructor(public NotifyServiceProvider :NotifyServiceProvider ,private excelService: ExcelService, public loadingController: LoadingController, public configApi: ConfigApiServiceProvider, public events: Events, public toastController: ToastController, public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController, public spinnerService: Ng4LoadingSpinnerService) {
    this.uploadFields = [
      { key: 'addnew', value: 'Always add as new record' },
      { key: 'update', value: ' Update duplicate ' },
    ]
  }

  generateExcel(f_withFile) {
    this.excelService.resetTemplateFields();
    this.excelService.generateExcel(f_withFile);
  }

  ionViewDidLoad() {
  }

  ngOnInit() {
    this.selectedValue = 'update';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'FieldName',
      textField: 'DisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.currentFolderTemplate = this.navParams.get('currentFolderTemplate')
    if (this.currentFolderTemplate[0] != undefined) {
      this.objCurrentTemplates = this.currentFolderTemplate[0]["fields"];
    }
    this.NotifyServiceProvider.getSubFolderFilterParams('before',this.currentFolderTemplate);
  }

  getField(e) {
    let data = e.event;
    if (data == "addnew") {
      this.uniqueField = true;
    } else {
      this.uniqueField = false;
      this.showDupliacte = true;
    }
    this.selectedValue = data;
  }



  downloadFile() {
    var file = this.selectFile.files[0];
    var fr = new FileReader();
    fr.readAsDataURL(file);

    var blob = new Blob([file], { type: "application/xlsx" });

    var objectURL = window.URL.createObjectURL(blob);
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, 'myFileName.xlsx');
      }
      // window.navigator.msSaveOrOpenBlob(blob, 'myFileName.xlsx');
    } else {
      var link = document.createElement('a');
      link.href = objectURL;
      link.download = "myFileName.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }

  importData(e) {
    if (this.emptyExcel) {
      if (this.selectFile) {
        this.presentLoading();
        this.formData.append('accessType', this.selectedValue);
        if (Object.keys(this.excelService.driveService.formGridTempProps).length != 0) {
          this.formData.append('parentKey', JSON.stringify(this.excelService.driveService.formGridTempProps['parentScreenParam']));
        }
        this.configApi.uploadExcelData(this.formData, this.excelUploadSuccess);
      } else {
        const toast = this.toastController.create({
          message: 'Please Select Excel File !!.',
          duration: this.configApi.toastDuration
        });
        toast.present();
      }
    } else {
      alert('Excel is empty!..please Enter the data and Try Again..')
    }
  }

  excelUploadSuccess = ((response) => {
    response = JSON.parse(response);
    if (response['result'] === 'success') {
      if(this.F_notifyUser){
        this.NotifyServiceProvider.getSubFolderFilterParams('After',this.currentFolderTemplate);
      }
      const toast = this.toastController.create({
        message: 'Excel Uploaded Successfully !!.',
        duration: this.configApi.toastDuration
      });
      toast.present();
      this.loader.dismiss();
      this.viewCtrl.dismiss(true);
      this.formData = new FormData();
      this.importFile = "";
      this.selectFile = "";
    } else if (response['result'] === 'invalid') {
      const toast = this.toastController.create({
        message: 'Invalid Excel Format...Please Upload Valid Format !!',
        duration: this.configApi.toastDuration
      });
      this.loader.dismiss();
      toast.present();
    } else if (response['result'] === 'FAIL') {
      const toast = this.toastController.create({
        message: ' Excel Upload Falied !!...Please Upload Valid Format !!',
        duration: this.configApi.toastDuration
      });
      this.loader.dismiss();
      toast.present();
    }
  })

  clearData() {
    this.viewCtrl.dismiss(true);
  }

  onFieldDeSelect(item) {
    var idx = this.selectField.findIndex(id => id == item.FieldName);
    if (idx) {
      this.selectField.splice(idx, 1);
      this.outputFields = this.selectField.toString();
    }
  }

  onFieldSelect(item) {
    if (this.selectField.length > 0) {
      for (var i = 0; i < this.selectField.length; i++) {
        if (this.selectField[i] !== item && item !== "") {
          this.selectField.push(item.FieldName);
          item = "";
        }
      }
    } else {
      this.selectField.push(item.FieldName);
    }
    this.outputFields = this.selectField.toString();
  }

  onFieldDeSelectAll(items) {
    this.selectField = [];
    this.outputFields = [];
  }

  onFieldSelectAll(items) {
    var result = items.map(function (val) {
      return val.FieldName;
    }).join(',');

    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].FieldName) {
          this.selectField.push(items[i].FieldName);
        }
      }
    }
    this.outputFields = result;
  }

  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Processing Please wait...'
    });
    this.loader.present();
  }
  receivefile(event) {
    this.selectFile = event.files;
    var file = event.FileList;
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      var data = XLSX.utils.sheet_to_json(ws);
      const objExcelLength = 1
      if (data.length > objExcelLength) {
        this.emptyExcel = true;
      } else {
        this.emptyExcel = false;
      }
    };
    reader.readAsBinaryString(event.FileList);
    this.formData.append('file', event.FileList);
  }

  F_notifyUser:boolean= false;
  notifyUser(event) {
    if (event.checked == true) {
      this.F_notifyUser = true;
    }
  }

}





// WEBPACK FOOTER //
// ./src/pages/excel-upload/excel-upload.ts